import React from 'react';
import { ProjectAPI } from 'api/project';
import { Avatar } from 'components/atoms/avatar';
import { QueryCombinerType } from 'components/organisms/tasks/combiner';
import { FieldType, SourceType } from 'components/organisms/tasks/fields';
import { TextFieldFilterOperationType } from 'components/organisms/tasks/filters/text';
import { FilterGroupType } from 'components/pages/types';
import { RoutePaths } from 'constant';
import { FIELD_ID_PROJECT_NAME } from 'utils/project-fields/use-project-native-fields-as-filterable-fields';
import { db } from 'workers/db';
import { CommandGroup, CommandItemType } from '../types';

export const useGetProjectsEntryForCmdk = (): CommandGroup => {
  return {
    groupId: 2000,
    filterable: true,
    getCommandItems: async (filterText) => {
      if (!filterText) {
        return [];
      }
      const resp = await ProjectAPI.paginateAndFilter({
        filter: [
          {
            id: FilterGroupType.Project,
            criteria: {
              type: TextFieldFilterOperationType.Contains,
              value: encodeURIComponent(filterText),
              field: {
                customField: false,
                private: false,
                sourceType: SourceType.Project,
                fieldName: 'projectName',
                fieldLabel: 'Project Name',
                type: FieldType.Text,
                fieldId: FIELD_ID_PROJECT_NAME,
              },
            },
          },
        ],
        endRow: 500,
        filterType: QueryCombinerType.All,
        sort: 'project*projectName.asc',
        startRow: 0,
      });

      return resp.data.map((e) => ({
        icon: () => (
          <Avatar src={e.customer?.companyUrl} name={e.customer?.companyName} />
        ),
        label: e.projectName,
        name: e.projectId.toString(),
        meta: {
          type: CommandItemType.Navigate,
          link: RoutePaths.projectDetail.replaceAll(
            ':projectId',
            e.projectId.toString(),
          ),
        },
      }));
    },
    label: 'Projects',
    name: 'Projects',
    tabbable: false,
  };
};

export const useGetIndexDbProjectsForCmdk = (): CommandGroup => {
  return {
    groupId: 2000,
    filterable: true,
    getCommandItems: async (filterText) => {
      if (!filterText) {
        return [];
      }
      const resp =
        (await db.projects
          .filter((project) =>
            project.projectName
              .toLowerCase()
              .includes(filterText.toLowerCase()),
          )
          .limit(100)
          .toArray()) || [];

      return resp.map((e) => ({
        icon: () => (
          <Avatar src={e.customer?.companyUrl} name={e.customer?.companyName} />
        ),
        label: e.projectName,
        name: e.projectId.toString(),
        meta: {
          inNewTab: true,
          type: CommandItemType.Navigate,
          link: RoutePaths.projectDetail.replaceAll(
            ':projectId',
            e.projectId.toString(),
          ),
        },
      }));
    },
    label: 'Projects',
    name: 'Projects',
    tabbable: false,
  };
};
